import { useSendEvent } from '~features/annals/useSendEvent';

import eventsRetentionNames from '../events/retention';

const useRetentionPopupShown = () =>
	useSendEvent(eventsRetentionNames.popupShown);

const useRetentionPopupCTAClicked = () =>
	useSendEvent(eventsRetentionNames.popupCTAClicked);

const annalsRetention = {
	useRetentionPopupShown,
	useRetentionPopupCTAClicked,
};

export default annalsRetention;
